/**
 * VNIS Information Column Configuration
 *
 * Uses shared column factory for base columns and config columns.
 */
import type { DataTableColumn } from '@/components/ui/data-table-customized'
import type { TFunction } from 'i18next'
import {
    ServiceDetailRow,
    buildServiceDetailColumns,
} from '@/modules/Service/utils/service-detail'

// ============================================================================
// Column Configuration - VNIS template
// ============================================================================

export const createVnisColumns = (
    t: TFunction,
    rows: ServiceDetailRow[] = []
): DataTableColumn<ServiceDetailRow>[] => {
    return buildServiceDetailColumns({
        t,
        rows,
        configPresets: [
            'domains',
            'cdnTraffics',
            'cdnRequests',
            'dnsQueries',
            'wafTraffics',
            'wafRequests',
            'peakCdnTraffics',
            'peakWafTraffics',
            'peakCdnRequests',
            'peakWafRequests',
        ],
    })
}
